export const projectsProjectDetailLauncherCapability = 'projects.detail-launcher.v1';
export const projectsProjectDetailLauncherSizes = [
    'compact',
    'standard',
    'wide',
    'large',
];
export function defineProjectsProjectDetailLauncher(metadata) {
    if (!metadata.supportedSizes.includes(metadata.defaultSize)) {
        throw new Error('A Project launcher default size must be supported.');
    }
    return Object.freeze({
        contractVersion: projectsProjectDetailLauncherCapability,
        ...metadata,
        supportedSizes: Object.freeze([...new Set(metadata.supportedSizes)]),
    });
}
//# sourceMappingURL=projects-project-detail-launcher.contract.js.map